<template>
  <div class="content newGuest">
    <div class="layui-fluid">
      <div class="layui-row">
        <div class="layui-col-md12">
          <div class="layui-row" style="margin-top: 20px;">
            <div class="layui-col-md12">
              <form class="layui-form" action>
                <div class="layui-form-item">
                  <label class="layui-form-label">所属会议:</label>
                  <el-select v-model="conference_id" placeholder="请选择" style="width:90%">
                    <el-option
                      v-for="item in options"
                      :key="item.id"
                      :label="item.name"
                      :value="item.id"
                    ></el-option>
                  </el-select>
                </div>
                <div class="layui-form-item">
                  <label class="layui-form-label">用户名:</label>
                  <div class="layui-input-block" style="width:90%">
                    <input
                      type="text"
                      name="name"
                      lay-verify="required"
                      autocomplete="off"
                      placeholder="请输入用户名"
                      class="layui-input"
                    />
                  </div>
                </div>
                <div class="layui-form-item">
                  <label class="layui-form-label">手机号:</label>
                  <div class="layui-input-block" style="width:90%">
                    <input
                      type="text"
                      name="tel"
                      lay-verify="required"
                      autocomplete="off"
                      placeholder="请输入手机号"
                      class="layui-input"
                    />
                  </div>
                </div>

                <div class="layui-form-item" style="text-align: center;">
                  <button type="button" class="layui-btn" lay-submit lay-filter="saveNewGuest">保存</button>
                  <button
                    type="button"
                    class="layui-btn layui-btn-primary"
                    id="sharemanagement"
                    @click="back"
                  >取消</button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import $ from "jquery";
export default {
  name: "NewGuest",
  data() {
    return {
      msg: "",
      tid: "",
      options: [],
      conference_id: "",
    };
  },
  created() {
    // this.tid = this.$route.params.id;
  },
  methods: {
    // /* 判断是否是编辑进入 */
    // bianji() {
    //   var _this = this;
    //   layui.use(
    //     [
    //       "jquery",
    //       "element",
    //       "form",
    //       "laydate",
    //       "upload",
    //       "layedit",
    //       "layer",
    //       "table",
    //     ],
    //     function () {
    //       var layer = layui.layer;
    //       var $ = layui.jquery;
    //       var element = layui.element;
    //       var form = layui.form;
    //       var laydate = layui.laydate;
    //       var upload = layui.upload;
    //       var nowTime = new Date().valueOf();
    //       var table = layui.table;
    //       var layedit = layui.layedit;
    //       if (_this.tid != undefined) {
    //         let url = "/ac1/conference/news/detail";
    //         var params = {
    //           id: _this.tid,
    //         };
    //         _this.$get(url, params).then((res) => {
    //           var lin = res.posts;
    //           _this.cid = lin.conference_id;
    //           if (lin.jump_status == 1) {
    //             $("#zixun_content").hide();
    //             $("#zixun_link").show();
    //           } else if (lin.jump_status == 0) {
    //             $("#zixun_content").show();
    //             $("#zixun_link").hide();
    //           }
    //           var objs = {
    //             title: lin.name,
    //             author: lin.author,
    //             media: lin.source,
    //             content: lin.text_content,
    //             link: lin.jump_link,
    //             is_link: lin.jump_status,
    //           };
    //           var img = lin.uploadImgId_url;
    //           $("#demo1").attr("src", img);
    //           _this.img_logo = $("#demo1").attr("src");
    //           form.val("example", objs);
    //         });
    //       }
    //     }
    //   );
    // },
    handleUploadConferenceCover() {
      $("#testlogos").click();
    },
    back() {
      this.$router.push({ path: "/Guest/UserManagement" });
    },
    // 公共方法
    handlePublics() {
      let _this = this;
      this.$nextTick(() => {
        layui.use(["jquery", "element", "table", "form"], function () {
          var $ = layui.jquery;
          var element = layui.element;
          var form = layui.form;
          var table = layui.table;
          form.on("submit(saveNewGuest)", function (data) {
            let url = "/ac1/conference/addFreeUser";
            let params = {
              data: [
                {
                  name: data.field.name,
                  tel: data.field.tel,
                  conference_id: _this.conference_id,
                },
              ],
            };
            _this
              .$post(url, params)
              .then((res) => {
                console.log(res);
                if (res.code == "1") {
                  _this.$message({
                    message: "保存成功",
                    type: "success",
                    duration: 1000,
                  });
                  _this.$router.push({ path: "/Guest/UserManagement" });
                } else {
                  _this.$message({
                    message: res.msg,
                    type: "warning",
                    duration: 2000,
                  });
                }
              })
              .catch((error) => {
                _this.$message({
                  message: error,
                  type: "error",
                  duration: 1000,
                });
              });
          });
          element.render();
          form.render();
          table.render();
        });
      });
    },
    /* 获取全部 */
    meet() {
      var _this = this;
      let url = "/ac1/conference/teamTotalConference";
      _this.$get(url).then((res) => {
        _this.options = res.posts;
      });
    },
  },
  mounted() {
    // 公共方法
    this.handlePublics();
    this.meet();
  },
  updated() {
    // 公共方法
    this.handlePublics();
  },
};
</script>

<style scoped>
.newGuest .layui-form-label {
  width: 110px;
}
</style>
